//import NullComponent from "common/components/NullComponent/NullComponent";
import {lazy} from "react";

export const importComponent = component => 
lazy(() => 
    import(`../../${component}`)
  );
